import RestClient from './restClient';

export default RestClient;
